import { createSelector } from 'reselect'

export const getLoginError = createSelector(
  (state) => state && state.user && state.user.auth && state.user.auth.formErrors && state.user.auth.formErrors.login
    ? state.user.auth.formErrors.login
    : null,
  (error) => error
)
